<template>
	<div class="grid grid-cols-8 bg-gradient-to-tr from-teal-500 to-teal-600">
		<div class="space-y-1 py-6 px-2 sm:px-4 col-span-5 sm:px-6 sm:col-span-4 md:col-span-6">
		    <div class="flex items-center justify-between space-x-3">
		      <h2 class="text-2xl lg:text-3xl font-semibold leading-7 font-medium text-white">
		        <slot></slot>
		      </h2>
		    </div>
		    <div>
		      <p class="text-sm lg:text-base leading-5 text-gray-200" v-if="description">
		       {{ description }}
		      </p>
		    </div>
		</div>
		<div class="h-10 self-center px-2 sm:px-0 sm:pr-3 col-span-3 sm:col-span-4 md:col-span-2 md:text-right">
			<tw-button align='false' size="md" @clicked="emailQuote" :disabled="isEmailLoading || hasSent" variant="secondary" v-if="email">
				<span v-if="hasSent">
					Sent!
				</span>
				<span v-else>
					<span v-if="!isEmailLoading">Email <span class="hidden sm:inline-block">Quote</span> <i class="fas fa-paper-plane ml-2"></i></span>
					<span v-else>Loading...</span>
				</span>
			</tw-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'headings.cardHeading',
		props: {
			description: {
				type: String
			},
			email: {
				default: true,
			}
		},
		data() {
			return {
				isEmailLoading: false,
				hasSent: false,
			}
		},
		watch: {
			hasSent() {
				const self = this;

				setTimeout(function() {
					self.hasSent = false
				}, 2000);
			}
		},
		methods: {
			emailQuote() {
				const self = this;

				self.isEmailLoading = true;

				// add new bike to quote
				axios.get('quote/email')
					 .then((resp) => {
					 	if(resp.data) {
				 			// self.feedback.push({
				 			// 	'type': 'success',
				 			// 	'message': 'A copy of the quote has been sent to you'
				 			// });
				 			self.hasSent 		= true;
				 			self.isEmailLoading = false;
					 	}
					 })
					 .catch(error => {
					 	// show feedback
			 			// self.feedback.push( {
			 			// 	'type': 'error',
			 			// 	'message': error
			 			// });
					 });
			},
		}
	}
</script>